import type React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png"; // Adjust path as needed

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  showLogo?: boolean;
  maxWidth?: "sm" | "md" | "lg";
  allowScroll?: boolean;
}

// AuthLayout.tsx
const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  subtitle,
  showLogo = true,
  maxWidth = "md",
  allowScroll = false,
}) => {
  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
  };

  // Updated container classes with modern gradient and glassmorphism effect
  const containerClasses = allowScroll
    ? "min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4 overflow-y-auto"
    : "h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4 overflow-hidden";

  return (
    <div className={containerClasses}>
      <div className={`w-full ${maxWidthClasses[maxWidth]} space-y-6`}>
        {/* Logo */}
        {showLogo && (
     <div className="text-center mb-4 mt-8">
  <Link to="/" className="inline-block">
    <img 
      src={logo} 
      alt="Company Logo" 
      className="h-12 w-auto mx-auto mb-2" 
    />
  </Link>
</div>
        )}
        
        <div className="bg-white/80 backdrop-blur-lg border border-white/20 rounded-2xl shadow-xl p-6 sm:p-8 md:p-10">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent mb-2">
              {title}
            </h2>
            {subtitle && <p className="text-gray-600">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
export default AuthLayout;